const DEFAULT_CURRENCY_OPTIONS = {
  style: 'currency',
  currency: 'BRL',
};
const DEFAULT_NFE_CURRENCY_OPTIONS = {
  minimumSignificantDigits: 7,
  maximumSignificantDigits: 7,
};
const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY HH:mm';

export default class Format {
  parseLocale(locale) {
    const defaultOptions = { style: 'currency' };

    if (locale === 'pt' || locale === 'pt-BR') {
      return {
        name: 'pt-BR',
        options: {
          ...defaultOptions,
          currency: 'BRL',
        },
      };
    }
    if (locale === 'en' || locale === 'en-US') {
      return {
        name: 'en-US',
        options: {
          ...defaultOptions,
          currency: 'USD',
        },
      };
    }
    // TODO: LOCALES EM ESPANHOL
    // 'es-AR'
    // 'es-BO'
    // 'es-CL'
    // 'es-CO'
    // 'es-CR'
    // 'es-DO'
    // 'es-EC'
    // 'es-ES'
    // 'es-GT'
    // 'es-HN'
    // 'es-MX'
    // 'es-NI'
    // 'es-PA'
    // 'es-PE'
    // 'es-PR'
    // 'es-PY'
    // 'es-SV'
    // 'es-US'
    // 'es-UY'
    // 'es-VE'
    // if (locale === 'es' || locale === 'es-AR') {
    //   return {
    //     name: 'es-AR',
    //     options: {
    //       ...defaultOptions,
    //       currency: 'ARS',
    //     },
    //   };
    // }

    return { name: 'pt-BR', options: DEFAULT_CURRENCY_OPTIONS };
  }

  /**
   * DOUBLE PARA DINHEIRO
   */
  doubleToCurrency(value, options = '', removePrefix = '', locale = '', addSuffix = false) {
    /**
     * Foi chamado o método parseLocale uilizando o brain.format pois quando o método doubleToCurrency é atribuído à uma variável,
     * ele perde o contexto da classe e não consegue acessar o método parseLocale com o this (this.parseLocale)
     */
    const localeData = brain.format.parseLocale(locale);
    let internalOptions = { ...(options || '') };

    if (!options)
      internalOptions = localeData.options || DEFAULT_CURRENCY_OPTIONS;

    let valueFormatted = new Intl
      .NumberFormat(localeData.name, internalOptions)
      .formatToParts(value);

    if (removePrefix) valueFormatted = valueFormatted.filter(i => i.type !== 'currency');
    if (addSuffix && _.get(internalOptions, 'currency')) valueFormatted.push({ value: ` ${internalOptions.currency}` });

    return valueFormatted.map(i => i.value).join('').trim();
  }

  doubleToDecimalPlacesCurrency({
    value,
    options = {},
    removePrefix,
    locale,
    addSuffix = false,
  }) {
    const decimalPlaces = value?.toString().split('.')[1]?.length || 2;

    const minimumFractionDigits = options.minimumFractionDigits || decimalPlaces;
    const maximumFractionDigits = options.maximumFractionDigits || decimalPlaces;

    return this.doubleToCurrency(
      value,
      {
        ...options,
        minimumFractionDigits: Math.min(minimumFractionDigits, maximumFractionDigits),
        maximumFractionDigits: Math.max(minimumFractionDigits, maximumFractionDigits),
      },
      removePrefix,
      locale,
      addSuffix,
    );
  }

  doubleToLocaleNumber(value, options, locale) {
    return this.doubleToCurrency(value, options || {}, true, locale);
  }

  doubleToNfeCurrency(value, options) {
    if (!options) options = DEFAULT_NFE_CURRENCY_OPTIONS;
    return new Intl.NumberFormat('pt-BR', options).format(value);
  }

  formatPercentage(val, options, locale) {
    return `${this.doubleToCurrency(val, options || { maximumFractionDigits: 1 }, true, locale)} %`;
  }

  /**
     * FORMATAÇÕES COM DATAS
     */

  diffDateWithNow(date) {
    return moment(date).fromNow();
  }

  diffDaysWithNow(date) {
    const diffDate = moment().diff(date, 'days');

    return `há ${diffDate} dias`;
  }

  differenceBetweenDates(date1, date2) {
    const diffDate = Math.abs(moment(date1).diff(date2, 'days'));
    return `${diffDate} ${diffDate !== 1 ? 'dias' : 'dia'}`;
  }

  formatDate(date, option = DEFAULT_DATE_FORMAT) {
    return moment(date).format(option);
  }

  formatSimpleDate(date) {
    return this.formatDate(date, 'DD/MM/YYYY');
  }

  /**
     * FORMATAÇÕES PARA CNPJ
     */
  formatCnpjCpf(arg) {
    if (!arg) return '';
    if (arg.length == 11)
      return this.formatCpf(arg);
    if (arg.length == 14)
      return this.formatCnpj(arg);

    return arg;
  }

  formatCnpj(cnpj) {
    if (!cnpj) cnpj = '';

    cnpj = cnpj.replace(/\D/g, '');
    cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2');
    cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2');
    cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2');
    return cnpj;
  }

  formatCpf(cpf) {
    if (!cpf) cpf = '';

    cpf = cpf.replace(/\D/g, '');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return cpf;
  }

  formatCep(v) {
    if (!v) v = '';

    v = v.replace(/\D/g, '');
    v = v.replace(/^(\d{5})(\d)/, '$1-$2');
    return v;
  }

  formatPhone(v) {
    if (!v) v = '';

    v = v.replace(/\D/g, '');
    if (v.length == 11) {
      v = v.replace(/(\d{2})(\d)/, '($1) $2');
      v = v.replace(/(\d{5})(\d)/, '$1-$2');
    } else if (v.length == 10) {
      v = v.replace(/(\d{2})(\d)/, '($1) $2');
      v = v.replace(/(\d{4})(\d)/, '$1-$2');
    } else if (v.length == 9) {
      v = v.replace(/(\d{5})(\d)/, '$1-$2');
    } else if (v.length == 8) {
      v = v.replace(/(\d{4})(\d)/, '$1-$2');
    }
    return v;
  }

  formatDigitableLine(v) {
    if (typeof v !== 'string') return '';

    let newV = v;

    newV = v.replace(/\D/g, '');

    newV = v.replace(/(\d{5})(\d{5})(\d{5})(\d{6})(\d{5})(\d{6})(\d{1})(\d)/, '$1.$2 $3.$4 $5.$6 $7 $8');

    return newV;
  }

  createDynamoTTL(date) {
    return Math.floor(new Date(date).getTime() / 1000);
  }
}
